import Settings from "@/models/settings.model";
import DeviceInfo from "@/models/deviceInfo.model";
import ApiService from "@/services/api.service";

class DeviceService extends ApiService {
  constructor() {
    super();
  }

  public async getActive(): Promise<Settings> {
    const url = "/api/Identity";
    const response = await this.axiosInstance.get<DeviceInfo>(url);
    return new Settings(response.data);
  }
}

export default new DeviceService();
